module.exports = __webpack_public_path__ + "img/symbol_3.d93c88c3.png";